// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__duPzr","top":"styles_top__247qv"};